import { observer } from "mobx-react-lite";
import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button, Grid, Segment, Popup } from "semantic-ui-react";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import ProjectTimeStore from "../../../app/stores/projecttimeStore";
import ProjectTimeList from "./ProjectTimeList";

const ProjectTimeDashboard: React.FC = () => {
  const projecttimeStore = useContext(ProjectTimeStore);
  const { loadProjectTimes, loadEmployees} = projecttimeStore;

  useEffect(() => {
     loadEmployees().then(() => loadProjectTimes());
  }, []);

  if (projecttimeStore.loadingInitial)
  return <LoadingComponent content="Loading Projects" />;
  
  return (
    <Segment>
      <Grid>
        <Grid.Column width={8}></Grid.Column>
        <Grid.Column width={5}>
        </Grid.Column>
        <Grid.Column textAlign="center" width={3}>
          <Button
            as={Link}
            to={"/hrmanagement/projecttimes-create"}
            color="linkedin"
            icon="add"
            content="Create New"
          />
        </Grid.Column>
      </Grid>
      <Grid>
        <Grid.Column>
          <ProjectTimeList />
        </Grid.Column>
      </Grid>
    </Segment>
  );
};

export default observer(ProjectTimeDashboard);
